export const RoutesNames = {
  Intro: '/intro',
  Profile: '/profile',
  Properties: '/properties',
  Contracts: '/contracts',
  Maintainers: '/maintainers',
  IndividualMaintainer: '/maintainers/:id',
  PropertyManagers: '/property-managers',
  PropertyManager: '/property-managers/:id',
  Violations: '/violations',
  Payment: '/settings',
  Integrations: '/integration-settings',
  Resman: '/integration-settings/:id',
  Support: '/support',
  IndividualContract: '/contracts/:id',
  Requests: '/requests',
  Policies: '/policies',
  DefaultPolices: '/default-policies',
  IndividualProperty: '/properties/:id/:tabName?',
  Onboarding: '/onboarding',
  Documents: '/documents',
  SuggestedTexts: '/suggested-texts',
  Landlords: '/landlords',
  IndividualLandlord: '/landlords/:id',
  Tenants: '/tenants',
  IndividualTenant: '/tenants/:id',
  Dashboard: '/dashboard',
  PolicyInput: '/policy-input',
  TenantPaymentSettings: '/payment-settings',
  TenantContractView: '/tenant-contracts/:id',
  TenantContracts: '/tenant-contracts',
  Curriculum: '/curriculum',
  SubCurriculum: '/curriculum/:curriculumId',
  CurriculumDetail: '/curriculum/:curriculumId/:id',
  StatePolicy: '/state-policy',
  ResetPassword: '/reset-password',
  SignUp: '/sign-up',
  Confirmation: '/confirmation',
  ResentTenantPassword: '/resent-tenant-password',
  Certificate: '/certificate/:courseId/:checkpointKey',
};
export const TabValues = {
  [RoutesNames.Intro]: 'intro',
  [RoutesNames.Profile]: 'profile',
  [RoutesNames.Properties]: 'properties',
  [RoutesNames.Contracts]: 'contracts',
  [RoutesNames.Maintainers]: 'maintainers',
  [RoutesNames.IndividualMaintainer]: 'maintainers',
  [RoutesNames.PropertyManagers]: 'maintainers',
  [RoutesNames.PropertyManager]: 'property-managers',
  [RoutesNames.Violations]: 'violations',
  [RoutesNames.Integrations]: 'settings',
  [RoutesNames.Payment]: 'settings',
  [RoutesNames.Resman]: 'settings',
  [RoutesNames.Support]: 'support',
  [RoutesNames.IndividualContract]: 'contracts',
  [RoutesNames.Requests]: 'requests',
  [RoutesNames.Policies]: 'policies',
  [RoutesNames.DefaultPolices]: 'policies',
  [RoutesNames.IndividualProperty]: 'properties',
  [RoutesNames.Onboarding]: 'onboarding',
  [RoutesNames.Documents]: 'documents',
  [RoutesNames.SuggestedTexts]: 'suggested-texts',
  [RoutesNames.Tenants]: 'tenants',
  [RoutesNames.IndividualTenant]: 'tenants',
  [RoutesNames.Landlords]: 'landlords',
  [RoutesNames.IndividualLandlord]: 'landlords',
  [RoutesNames.Dashboard]: 'dashboard',
  [RoutesNames.PolicyInput]: 'policy-input',
  [RoutesNames.TenantPaymentSettings]: 'payment-settings',
  [RoutesNames.TenantContractView]: 'tenant-contracts',
  [RoutesNames.TenantContracts]: 'tenant-contracts',
  [RoutesNames.Curriculum]: 'curriculum',
  [RoutesNames.CurriculumDetail]: 'curriculum',
  [RoutesNames.StatePolicy]: 'state-policy',
  [RoutesNames.ResetPassword]: 'reset-password',
  [RoutesNames.SignUp]: 'sign-up',
  [RoutesNames.Confirmation]: 'confirmation',
  [RoutesNames.ResentTenantPassword]: 'resent-tenant-password',
  [RoutesNames.Certificate]: 'certificate',
};
